class ValidatePassword extends ValidatePage {
    constructor(_parent) {
        super();
        this.parent = _parent;
        this.regex = /(?=[#$-/:-?{-~!"^_`\[\]a-zA-Z]*([0-9#$-/:-?{-~!"^_`\[\]]))(?=[#$-/:-?{-~!"^_`\[\]a-zA-Z0-9]*[a-zA-Z])[#$-/:-?{-~!"^_`\[\]a-zA-Z0-9]{6,}/;
        this.password = { elm: '', id: '', classlist: '',  value: '' };
        this.confirmPassword = { elm: '', id: '', classlist: '', value: '' };
        this.is_valid = false;

        this.debug = this.parent.debug.extends.ValidatePassword; // Turn on debugger in ValidatePage
    }  

    async _validate($this){
        this.define_elems($this);
        this.is_valid = await this.process_validations();

        if(this.debug)
            console.log(this , "ValidatePassword - debug");

        return this.is_valid
    }

    define_elems($this){
        if($this.hasClass('js-password')){
            this.password = this.parent.define_elem($this);
            this.confirmPassword = this.get_confirm_password($this);    
        }

        if($this.hasClass('js-confirm-password')){
            this.confirmPassword = this.parent.define_elem($this);
            this.password = this.get_password($this);
        }
    }

    async process_validations(){
        if(this.password.value == ''){
            this.parent.validate_required(this.password.elm);
            return false;
        }else if(this.password.value != ''){
            // if(this.password.elm.hasClass('xyz-class')) // escapes regex cond for passwords pre validation if/when we get to this point
            //     return true

            if(this.password.value.length < this.password.elm.attr('minlength')){
                if(this.password.elm.attr('minlength') > 1)
                    var msg = get_language_translation('MINIMUM_REQUIRED_LENGTH_OF_LANG') + ' ' + this.password.elm.attr('minlength')
                else
                    var msg = get_language_translation('LANG_ERR_ONE_CHAR_REQUIRED')
    
                this.parent.failed_obj_push( { target: this.password.id, msg: msg } );

                return false;
            }
            else if(this.password.value.length > this.password.elm.attr('maxlength') && this.password.elm.attr('minlength') > 1){
                var msg = get_language_translation('LANG_LABEL_MAX_LENGTH') + ' - ' + this.password.elm.attr('maxlength')
                this.parent.failed_obj_push( { target: this.password.id, msg: msg } );

                return false;
            }
            else if(this.password.value != this.confirmPassword.value){
                this.parent.failed_obj_push( { target: this.password.id, msg: get_language_translation('LANG_MSG_PASSWORDS_DO_NOT_MATCH') } );
                return false;
            }

            var labels = am.$('#am-password-criteria-wrapper > label.invalid');
            if(labels.length > 0){
                this.parent.failed_obj_push( { target: this.password.id, msg: get_language_translation('LANG_LABEL_ERR_MSG_SPACES') } );
                return false;
            }
        }

        return true;
    }

    get_confirm_password($el){
        const $passwordsContainer = this.get_passwords_container($el);
        const $confirm_password = $passwordsContainer.find('.js-confirm-password');
        var confirmPassword = this.parent.define_elem($confirm_password);

        return confirmPassword;
    }

    get_password($el){
        const $passwordsContainer = this.get_passwords_container($el);
        const $password = $passwordsContainer.find('.js-password');
        var password = this.parent.define_elem($password);
    
       return password
    }

    get_passwords_container($el){
        const $passwordsContainer = $el.parent().closest('.am-section-section');
        return $passwordsContainer;
    }
} 